export const BusinessProfileModel = {
  id: "",
  userId: "",
  businessName: "",
  email: "",
  leagalBusinessName: "",
  contactlegalname: "",
  contactpreferredname: "",
  phone: null,
  birthday: null,
  gender: null,
  country: null,
  address: null,
  city: null,
  state: null,
  zipCode: null,
  description: null,
  website: null,
  businessLogo: null,
  video: "",
  numberofemployees: null,
  currency: null,
  stateId: null,
  countryId: null,
  businessLogoUrl:null,
};
